import React, { useState, useEffect, useRef } from "react";
import GoogleMapReact from "google-map-react";

const CustomComponent = ({ text }) => (
  <div>
    <img src="/marker-icon.png" alt="Location marker" />
  </div>
);

const GoogleMapComponent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  const center = {
    lat: 18.57002,
    lng: 73.78122,
  };
  const zoom = 11;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: "200px", // Load 200px before entering viewport
        threshold: 0,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} style={{ height: "100vh", width: "100%", backgroundColor: "#f5f5f5" }}>
      {isVisible ? (
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAPS_API_KEY || "" }}
          defaultCenter={center}
          defaultZoom={zoom}
        >
          <CustomComponent lat={18.57789} lng={73.78116} text="Marker" />
        </GoogleMapReact>
      ) : (
        <div style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#666"
        }}>
          Loading map...
        </div>
      )}
    </div>
  );
};

export default GoogleMapComponent;
